import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Banner from './components/Banner/Banner';
import About from './components/About/About';
import Project from './components/Projects/Project';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import Blog from './components/Blogs/Blog';
import Home from './components/Home/Home';
import Project1 from './components/Project1/Project1';
import Project2 from './components/Project2/Project2';
import Project3 from './components/Project3/Project3';


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header></Header>
        <Switch>
          <Route exact path="/">
            <Home></Home>
          </Route>
          <Route path="/home">
            <Home></Home>
          </Route>
          <Route path="/banner">
            <Banner></Banner>
          </Route>
          <Route path="/about">
            <About></About>
          </Route>
          <Route path="/project">
            <Project></Project>
          </Route>
          <Route path="/project1">
            <Project1></Project1>
          </Route>
          <Route path="/project2">
            <Project2></Project2>
          </Route>
          <Route path="/project3">
            <Project3></Project3>
          </Route>
          <Route path="/blog">
            <Blog></Blog>
          </Route>
          <Route path="/contact">
            <Contact></Contact>
          </Route>
        </Switch>
        <Footer></Footer>
      </BrowserRouter>
    </div>
  );
}

export default App;
